<div class="chart-container">
  <highcharts-chart [Highcharts]="Highcharts" [options]="chartData"
    [style]="getChartStyle(true)" >
  </highcharts-chart>
</div>